function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import p from "@ambiki/combobox";

function a(i) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var e;
  return function () {
    for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
      n[_key] = arguments[_key];
    }

    clearTimeout(e), e = window.setTimeout(function () {
      clearTimeout(e), i.apply(void 0, n);
    }, t);
  };
}

function r() {
  return new Promise(requestAnimationFrame);
}

var u = "data-autocomplete-value",
    c = "data-empty",
    o = /*#__PURE__*/function () {
  function o(t, e, n) {
    var _this$resetButton;

    _classCallCheck(this, o);

    this.element = void 0;
    this.input = void 0;
    this.list = void 0;
    this.resetButton = void 0;
    this.isMultiple = void 0;
    this.combobox = void 0;
    this.listObserver = void 0;
    this.element = t, this.input = e, this.list = n, this.list.hidden = !0, this.isMultiple = this.element.hasAttribute("multiple"), this.combobox = new p(this.input, this.list, {
      isMultiple: this.isMultiple
    }), this.input.setAttribute("spellcheck", "false"), this.input.setAttribute("autocomplete", "off"), this.list.setAttribute("tabindex", "-1"), this.resetButton = this.element.querySelector("[data-autocomplete-reset]"), this.resetButton && !this.resetButton.hasAttribute("aria-label") && this.resetButton.setAttribute("aria-label", "reset autocomplete"), this.onFocus = this.onFocus.bind(this), this.onPointerDown = this.onPointerDown.bind(this), this.onKeydown = this.onKeydown.bind(this), this.onCommit = this.onCommit.bind(this), this.onInput = a(this.onInput.bind(this), 300), this.onBlur = this.onBlur.bind(this), this.handleReset = this.handleReset.bind(this), this.input.addEventListener("focus", this.onFocus), this.input.addEventListener("blur", this.onBlur), this.input.addEventListener("pointerdown", this.onPointerDown), this.input.addEventListener("keydown", this.onKeydown), this.input.addEventListener("input", this.onInput), this.list.addEventListener("combobox:commit", this.onCommit), (_this$resetButton = this.resetButton) !== null && _this$resetButton !== void 0 && _this$resetButton.addEventListener("click", this.handleReset), this.listObserver = new MutationObserver(this.onListToggle.bind(this)), this.listObserver.observe(this.list, {
      attributes: !0,
      attributeFilter: ["hidden"]
    });
  }

  _createClass(o, [{
    key: "destroy",
    value: function destroy() {
      var _this$resetButton2;

      this.input.removeEventListener("focus", this.onFocus), this.input.removeEventListener("blur", this.onBlur), this.input.removeEventListener("pointerdown", this.onPointerDown), this.input.removeEventListener("keydown", this.onKeydown), this.input.removeEventListener("input", this.onInput), this.list.removeEventListener("combobox:commit", this.onCommit), (_this$resetButton2 = this.resetButton) !== null && _this$resetButton2 !== void 0 && _this$resetButton2.removeEventListener("click", this.handleReset), this.listObserver.disconnect();
    }
  }, {
    key: "onListToggle",
    value: function onListToggle() {
      this.list.hidden ? (s(this.element, "hide"), this.combobox.stop(), this.list.removeAttribute(c), s(this.element, "hidden"), d(this)) : (s(this.element, "show"), this.combobox.start(), s(this.element, "shown"));
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      !this.list.hidden || this.openAndInitializeList();
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown() {
      !this.list.hidden || document.activeElement === this.input && this.openAndInitializeList();
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(t) {
      switch (t.key) {
        case "Escape":
          this.list.hidden || (this.list.hidden = !0, t.preventDefault(), t.stopPropagation());
          break;

        case "ArrowDown":
          t.altKey && this.list.hidden && (this.openAndInitializeList(), t.preventDefault(), t.stopPropagation());
          break;

        case "ArrowUp":
          t.altKey && !this.list.hidden && (this.list.hidden = !0, t.preventDefault(), t.stopPropagation());
          break;

        default:
          break;
      }
    }
  }, {
    key: "onInput",
    value: function onInput() {
      this.list.hidden && (this.list.hidden = !1);
      var t = this.input.value.trim();
      this.filterListWithQuery(t), this.combobox.setActive(this.combobox.visibleOptions[0]), this.list.toggleAttribute(c, this.combobox.visibleOptions.length === 0);
    }
  }, {
    key: "onCommit",
    value: function onCommit(t) {
      var e = t.target;
      if (!(e instanceof HTMLElement)) return;
      var n = e.getAttribute(u) || e.textContent;
      this.isMultiple ? this.input.value && (this.inputValue = "", this.filterListWithQuery(), this.combobox.setActive(e)) : (this.inputValue = n, this.list.hidden = !0), s(this.element, "selected", {
        detail: {
          relatedTarget: e
        }
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(t) {
      var e = t.relatedTarget;

      if (!(e instanceof HTMLElement)) {
        this.list.hidden = !0;
        return;
      }

      e.closest('[role="listbox"]') ? this.input.focus() : this.list.hidden = !0;
    }
  }, {
    key: "handleReset",
    value: function () {
      var _handleReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        var _iterator, _step, e;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t.preventDefault();
                _iterator = _createForOfIteratorHelper(this.combobox.options.filter(h));

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    e = _step.value;
                    e.setAttribute("aria-selected", "false");
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                d(this);
                this.input.focus();
                _context.next = 7;
                return r();

              case 7:
                this.list.hidden || (this.list.hidden = !0);
                s(this.element, "reset");

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleReset(_x) {
        return _handleReset.apply(this, arguments);
      }

      return handleReset;
    }()
  }, {
    key: "openAndInitializeList",
    value: function openAndInitializeList() {
      this.list.hidden = !1, this.filterListWithQuery(), b(this);
    }
  }, {
    key: "filterListWithQuery",
    value: function filterListWithQuery() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.combobox.options.forEach(f(t, {
        matching: u
      }));
    }
  }, {
    key: "inputValue",
    set: function set(t) {
      this.input.value = t, this.input.dispatchEvent(new Event("change"));
    }
  }]);

  return o;
}();

function b(_x2) {
  return _b.apply(this, arguments);
}

function _b() {
  _b = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(i) {
    var t, n;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            t = i.combobox, n = t.options.filter(h)[0] || t.visibleOptions[0];
            _context2.next = 3;
            return r();

          case 3:
            t.setActive(n);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _b.apply(this, arguments);
}

function f(i, _ref) {
  var t = _ref.matching;
  return function (e) {
    if (i) {
      var _ref2;

      var m = (_ref2 = e.getAttribute(t) || e.textContent) === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase().includes(i.toLowerCase());
      e.hidden = !m;
    } else e.hidden = !1;
  };
}

function d(i) {
  var t = i.combobox,
      e = i.isMultiple,
      n = t.options.filter(h)[0];
  e || !n ? i.inputValue = "" : i.inputValue = n.getAttribute(u) || n.textContent;
}

function h(i) {
  return i.getAttribute("aria-selected") === "true";
}

function s(i, t) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  i.dispatchEvent(new CustomEvent("auto-complete:".concat(t), _objectSpread({
    bubbles: !0
  }, e)));
}

var l = /*#__PURE__*/function (_HTMLElement) {
  _inherits(l, _HTMLElement);

  var _super = _createSuper(l);

  function l() {
    var _this;

    _classCallCheck(this, l);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.autocomplete = null;
    return _this;
  }

  _createClass(l, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var t = this.querySelector('input:not([type="hidden"])'),
          e = this.getAttribute("for");
      if (!e) return;
      var n = document.getElementById(e);
      !(t instanceof HTMLElement) || !n || (this.autocomplete = new o(this, t, n));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$autocomplete;

      (_this$autocomplete = this.autocomplete) === null || _this$autocomplete === void 0 ? void 0 : _this$autocomplete.destroy();
    }
  }]);

  return l;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

window.customElements.get("auto-complete") || (window.AutoCompleteElement = l, window.customElements.define("auto-complete", l));
export { l as default };